import { usePostApi } from '@/apiError/apiCreate';
import { useMutateGetApi } from '@/apiError/apiShow';
import { useUpdateApi } from '@/apiError/apiUpdate';
import { AntButton } from '@/common/ant-components/AntButton';
import { focusNode } from '@/pages/reports/reuse/helpers';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import CustomSelect from '@/utils/search/Search';
import { handleKeyDown } from '@/utils/validation/FormValidation';
import { Col, Form, Input, Row, Space } from 'antd';
import { useEffect, useRef, useState } from 'react';

const GroupForm = ({
  referenceId,
  onClose = () => {},
  refreshTable = () => {},
  refetchFlag = false,
  setRefetchFlag,
}) => {
  const [form] = Form.useForm();
  const [groupList, setGroupList] = useState([]);
  // const [loading, setLoading] = useState(false);

  //tanstack query create
  const { mutate, isPending: createLoading } = usePostApi({
    url: '/account/groups/',
  });
  const { mutate: updateMutate, isPending: updateLoading } = useUpdateApi();
  const {
    mutate: getMutate,
    data: getMutateData,
    isPending: getDetailLoading,
  } = useMutateGetApi();
  const { mutate: getAllMutate, isPending: getListLoading } = useMutateGetApi();

  const loading =
    createLoading || updateLoading || getDetailLoading || getListLoading;

  // Fetches the list of groups for the dropdown
  const fetchGroupList = async () => {
    form.resetFields();
    // try {
    //   setLoading(true);
    //   const response = await ShowAllData.showDetails('/account/groups/');
    //   setGroupList(response.data);
    // } finally {
    //   setLoading(false);
    // }

    getAllMutate(
      { url: `/account/groups/` },
      {
        onSuccess: (data) => {
          setGroupList(data?.data);
        },
      },
    );
  };

  // Fetches group details by ID if in edit mode
  const fetchGroupDetails = (id) => {
    // try {
    //   setLoading(true);
    //   const response = await ShowDataById.getDataById(`/account/group/${id}/`);
    //   form.setFieldsValue(response.data);
    // } finally {
    //   setLoading(false);
    // }

    getMutate(
      { url: `/account/group/${id}/` },
      {
        onSuccess: (data) => {
          form.setFieldsValue(data.data);
        },
      },
    );
  };

  // Handles form submission for both create and update
  const handleFormSubmit = async () => {
    const values = form.getFieldsValue();

    if (referenceId) {
      const selectedGroup = groupList?.find(
        (group) => group.groupName === values.parentName,
      );
      const dataToSend = {
        ...values,
        parentId: selectedGroup?.referenceId || null,
      };

      // await UpdateAllData.updateData(
      //   `/account/group/${referenceId}/`,
      //   dataToSend,
      // );
      updateMutate(
        {
          url: `/account/group/${referenceId}/`,
          values: dataToSend,
        },
        {
          onSuccess: () => {
            onClose();
            form.resetFields();
            refreshTable();
            setRefetchFlag((prev) => !prev);
          },
        },
      );
    } else {
      const dataToSend = {
        ...values,
        parentId: values.parentName,
      };
      // await CreateAllData.createItem('/account/groups/', dataToSend);
      mutate(dataToSend, {
        onSuccess: () => {
          onClose();
          form.resetFields();
          refreshTable();
          setRefetchFlag((prev) => !prev);
        },
      });
    }
  };

  // Initialize the component
  useEffect(() => {
    fetchGroupList();
    if (referenceId) fetchGroupDetails(referenceId);
  }, [referenceId, refetchFlag]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.code === 'NumpadEnter') {
      e.preventDefault();
      const formElements = Array.from(
        e.currentTarget.querySelectorAll(
          'input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ),
      ).filter((el) => !el.hasAttribute('disabled'));

      const index = formElements.indexOf(e.target);
      if (index > -1 && index < formElements.length - 1) {
        const next = formElements[index + 1];
        next?.focus();
      }
    }
    if (e.key === 'F12') {
      e.preventDefault();
      form.submit();
    }
  };

  return (
    <div>
      <LoadingOverlay loading={loading} />
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFormSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e);
        }}
      >
        <Row gutter={24}>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              style={{ marginBottom: '30px' }}
              className="username"
              label="Select Group"
              name="groupId"
              rules={[
                { required: true, message: 'Please select any one group!' },
              ]}
            >
              <CustomSelect
                style={{ width: '' }}
                // selectRef={selectRef}
                placeholder="Select group"
                options={groupList?.map((group) => ({
                  value: group.groupId,
                  label: group.groupName,
                }))}
                showAddButton={false}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              style={{ marginBottom: '30px' }}
              className="username"
              label={referenceId ? 'Edit Category' : 'Add New Category'}
              name="groupName"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.reject('Please enter category name!');
                    } else if (!/^[a-zA-Z\s]+$/.test(value)) {
                      return Promise.reject('Please enter text only.');
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              validateTrigger="onChange"
            >
              <Input type="text" />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Space size="large">
            <AntButton color="green" htmlType="submit" loading={loading}>
              {referenceId ? 'Update' : 'Create'}
            </AntButton>
            <AntButton color="red" onClick={onClose}>
              Cancel
            </AntButton>
          </Space>
        </div>
      </Form>
    </div>
  );
};

export default GroupForm;
